export const numberWithCommas = (num) => {
    if (num || num === 0) {
        const value = Math.round(num).toString();

        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    return 'N/A';
};
